// form 转换器
export const parser = (data) => {
  for(let key in data){
    let val = data[key]
    if(Object.prototype.toString.call(val) == '[object Object]'){
      if(!('initialValue' in val)) val.initialValue = null
      data[key] = [key , val]
    }else{
      let options = {  }
      //if( key !== null ){
      options.initialValue = val || null
      //}
      data[key] = [key , options]
    }
  }
  return data
}

const findByName = (node , name) => {

  if( node.$options.name == name){
    return node
  }else{
    if(node.$children && node.$children.length){
      for(let i = 0; i < node.$children.length ; i++){
        let hit = findByName(node.$children[i] , name)
        if(hit){
          return hit
        }
      }
      return null
    }else{
      return null
    }
  }
}

export const createForm = (node) => findByName(node , 'Form')